var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-affiliations pt-2 px-0" },
    [
      _vm.filterComponent
        ? [
            _c(
              "v-layout",
              {
                staticClass: "mt-4",
                attrs: {
                  "align-center": "",
                  "justify-center": "",
                  column: "",
                  "fill-height": ""
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit($event)
                  }
                }
              },
              [
                _c("v-select", {
                  staticClass: "v-select__form mb-3",
                  staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                  attrs: {
                    items: _vm.productsType,
                    label: "Producto",
                    "append-icon": "icon-ic-expand-more",
                    placeholder: "Todos los tipos de productos"
                  },
                  on: { change: _vm.selectProductType },
                  model: {
                    value: _vm.productType,
                    callback: function($$v) {
                      _vm.productType = $$v
                    },
                    expression: "productType"
                  }
                }),
                _c("v-select", {
                  staticClass: "v-select__form mt-20 mb-20",
                  staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                  attrs: {
                    items: _vm.products,
                    label: "Sub-Producto",
                    "append-icon": "icon-ic-expand-more",
                    placeholder: "Todos los productos"
                  },
                  on: { change: _vm.selectIdProduct },
                  model: {
                    value: _vm.product,
                    callback: function($$v) {
                      _vm.product = $$v
                    },
                    expression: "product"
                  }
                }),
                _c("v-select", {
                  staticClass: "v-select__form mt-20 mb-20",
                  staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                  attrs: {
                    items: _vm.typeOfSolutions,
                    label: "Estado de solicitud",
                    "append-icon": "icon-ic-expand-more",
                    placeholder: "Tipo de solución"
                  },
                  model: {
                    value: _vm.typeOfProduct,
                    callback: function($$v) {
                      _vm.typeOfProduct = $$v
                    },
                    expression: "typeOfProduct"
                  }
                }),
                _c("date-option", {
                  ref: "DateOption",
                  attrs: { labelDateOption: "Fecha de ingreso" },
                  on: { input: _vm.dateOptionSelected, click: _vm.dateAdmin }
                }),
                _c("date-option", {
                  ref: "DateOption",
                  attrs: { labelDateOption: "Fecha Alta" },
                  on: { input: _vm.dateOptionSelected, click: _vm.dateHight }
                }),
                _c("v-select", {
                  staticClass: "v-select__form mb-20",
                  staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                  attrs: {
                    items: _vm.departments,
                    label: _vm.Departamento,
                    "append-icon": "icon-ic-expand-more",
                    placeholder: "Todos los departamentos"
                  },
                  model: {
                    value: _vm.department,
                    callback: function($$v) {
                      _vm.department = $$v
                    },
                    expression: "department"
                  }
                }),
                _c("v-select", {
                  staticClass: "v-select__form mb-20",
                  staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                  attrs: {
                    items: _vm.provinces,
                    label: "Provincia",
                    "append-icon": "icon-ic-expand-more",
                    placeholder: "Todas las Provincias"
                  },
                  model: {
                    value: _vm.province,
                    callback: function($$v) {
                      _vm.province = $$v
                    },
                    expression: "province"
                  }
                }),
                _c("v-select", {
                  staticClass: "v-select__form mb-20",
                  staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                  attrs: {
                    items: _vm.districts,
                    label: "Distrito",
                    "append-icon": "icon-ic-expand-more",
                    placeholder: "Todos los distritos"
                  },
                  model: {
                    value: _vm.district,
                    callback: function($$v) {
                      _vm.district = $$v
                    },
                    expression: "district"
                  }
                }),
                _c("v-select", {
                  staticClass: "v-select__form mb-35p",
                  staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                  attrs: {
                    items: _vm.statusOptions,
                    label: "Estado",
                    "append-icon": "icon-ic-expand-more",
                    "item-value": "statusOptions[0]",
                    placeholder: "Concretado"
                  },
                  model: {
                    value: _vm.status,
                    callback: function($$v) {
                      _vm.status = $$v
                    },
                    expression: "status"
                  }
                })
              ],
              1
            ),
            _c(
              "v-layout",
              {
                attrs: {
                  "align-center": "",
                  "justify-center": "",
                  column: "",
                  "fill-height": ""
                }
              },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn-filters btn-filter--second",
                    staticStyle: { color: "#7E868B" },
                    attrs: { flat: "" },
                    on: { click: _vm.clearFilters }
                  },
                  [_vm._v("Limpiar filtros")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "btn-filters btn-filter--primary",
                    on: { click: _vm.onSubmit }
                  },
                  [_vm._v("Aplicar filtros")]
                )
              ],
              1
            )
          ]
        : [
            _c(
              "v-layout",
              {
                attrs: {
                  "align-center": "",
                  "justify-center": "",
                  row: "",
                  "fill-height": ""
                }
              },
              [
                _c("search-box", {
                  attrs: { placeholder: "BUSCAR RAZÓN SOCIAL, RUC, CÓDIGO" },
                  on: { search: _vm.search }
                }),
                !_vm.rankingShow
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "elevation-0 v-btn--filter",
                        on: { click: _vm.showFilter }
                      },
                      [_c("v-icon", [_vm._v("icon-ic-filtrar")])],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("v-layout", { staticClass: "px-0" }, [
              _c(
                "div",
                { staticClass: "stepper__container ranking__container" },
                [
                  _vm.processShow
                    ? _c("mobileAffiliationsTable", {
                        staticClass: "mt-0",
                        attrs: {
                          data: _vm.newData || [],
                          render: _vm.processShow
                        }
                      })
                    : _vm._e(),
                  _vm.workedShow
                    ? _c("mobileWorkedTable", { attrs: { data: _vm.newData } })
                    : _vm._e(),
                  _vm.rankingShow
                    ? _c("mobileRankingTable", { attrs: { data: _vm.newData } })
                    : _vm._e()
                ],
                1
              )
            ]),
            _c("v-progress-circular", {
              staticClass: "ranking__table__loader",
              class: { active: _vm.loading },
              attrs: { width: 3, color: "primary", indeterminate: "" }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a05a672a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a05a672a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a05a672a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/_id.vue
// module chunks = 0